module.exports = __webpack_public_path__ + "img/content-02.e8c7036d.jpg";